<template>
  <div id="ship-detail-sections-wrapper">
    <section v-if="shipData" id="section-schiff">

      <div class="no-padding ship-image-wrapper">
        <a class="img-link">
          <responsive-image v-if="getLargestAvailableImage(shipData.bilder[0].filenames)"
                            :alt="shipData.bezeichnung"
                            :title="shipData.bezeichnung"
                            :src="getLargestAvailableImage(shipData.bilder[0].filenames)"
                            :src-xs="shipData.bilder[0].filenames.img800_3x1"
                            :src-sm="shipData.bilder[0].filenames.img800_3x1"
                            :src-md="shipData.bilder[0].filenames.img1200_3x1"
                            :src-lg="shipData.bilder[0].filenames.img1200_3x1"
                            fixed-aspect-ratio="3/1"
                            :lazy-load="false"
                            img-class="img-responsive"/>
        </a>
        <a v-if="hasShipPano" data-fancybox="krpano-ship" data-src="#krpano-ship" href="#krpano-ship"
           class="fancybox-pano btn btn-round-badge ship-pano-badge" v-on:click="showShipPano = true;">360°<br/>Panorama
        </a>
        <pano-viewer v-if="hasShipPano"
                     :lazy-load="true"
                     id="krpano-ship"
                     :show-pano="showShipPano"
                     :logo="logo"
                     :scenes="shipPano"
                     :debug="false"
                     :title="shipData.bezeichnung"
                     :xml="'/packages/travel/data/panorama/' + shipData.schiffscode + '/pano_new.xml'"
                     pano_image_dir="pano_images/"
                     hotspot_dir="/packages/travel/themes/mittelthurgau/images/pano/">
        </pano-viewer>
      </div>

      <div class="container wider-padding ship-detail-sections ship-detail-overview">
        <h2 class="mt-0">{{ shipData.name }}</h2>
        <div class="row">
          <div class="col-sm-6">
            <p v-if="shipData.beschrieb" v-html="shipData.beschrieb"></p>
          </div>
          <div class="col-sm-6">
            <div v-if="shipData.technischedaten" class="well ship-technical-data">
              <h4>Technische Daten</h4>
              <table class="table">
                <thead></thead>
                <tbody>
                <tr v-for="td in shipData.technischedaten">
                  <th>{{ td.spalte1 }}</th>
                  <td>{{ td.spalte2 }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <h2 v-if="shipData.kabine && shipData.kabine.titel && shipData.kabine.beschreibung && shipData.kabine.beschreibung[0].text">{{ shipData.kabine.titel }}</h2>
        <div v-if="shipData.kabine" class="row">
          <div v-if="shipData.kabine.beschreibung && shipData.kabine.beschreibung[0].text" class="col-sm-6">
            <p v-html="shipData.kabine.beschreibung[0].text"></p>
          </div>
          <div class="col-sm-6">
            <div v-if="shipData.deckplaene" class="ship-deck-map">
              <div class="image-gallery" v-for="b in shipData.deckplaene.bilder">
                <h4>{{ shipData.deckplaene.bezeichung }}</h4>
                <a v-if="getLargestAvailableImage(b.filenames, '')"
                   class="img-link"
                   data-fancybox="deckplan"
                   :data-caption="shipData.deckplaene.bezeichung"
                   :href="getLargestAvailableImage(b.filenames, '')">
                  <responsive-image :alt="shipData.deckplaene.bezeichung"
                                    :title="shipData.deckplaene.bezeichung"
                                    :src="getLargestAvailableImage(b.filenames, '')"
                                    :src-xs="b.filenames.img800"
                                    :src-sm="b.filenames.img800"
                                    :src-md="b.filenames.img800"
                                    :src-lg="b.filenames.img800"
                                    img-class="travel-detail-picture img-responsive"/>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div id="sectioin-kabinen" v-if="shipData && shipData.kabine">
        <div class="container ship-cabins bg-lightgray wider-padding ship-detail-sections">
          <div class="ship-cabin-item" v-for="k in shipData.kabine.kabinenDeck">
            <div class="row" v-if="k.bilder">
              <div class="col-xs-12">
                <h3 class="ship-cabin-title">{{ k.kabinen_deck }}</h3>
                <span class="ship-cabin-legend">
                                        <div class="ship-cabin-legend-item" :style="'background-color:#' + hex + ';'"
                                             v-for="hex in k.farben"></div>
                                    </span>
              </div>
              <div v-if="k.bilder[1]" class="col-xs-12 col-sm-6 image-gallery">
                <a v-if="getLargestAvailableImage(k.bilder[1].filenames, '3x2')"
                   class="img-link "
                   data-fancybox="kabinen"
                   :href="getLargestAvailableImage(k.bilder[1].filenames, '3x2')">
                  <responsive-image alt=""
                                    title=""
                                    :src="getLargestAvailableImage(k.bilder[1].filenames, '3x2')"
                                    :src-xs="k.bilder[1].filenames.img800_3x2"
                                    :src-sm="k.bilder[1].filenames.img400_3x2"
                                    :src-md="k.bilder[1].filenames.img400_3x2"
                                    :src-lg="k.bilder[1].filenames.img800_3x2"
                                    img-class="ship-detail-picture img-responsive ship-cabin-image"/>
                </a>
              </div>
              <div v-if="k.bilder[0]" class="col-xs-12 col-sm-6 image-gallery">
                <div class="ship-cabin-plan-wrapper">
                  <a v-if="getLargestAvailableImage(k.bilder[0].filenames)"
                     class="img-link"
                     data-fancybox="kabinenplan"
                     :data-caption="k.kabinen_deck"
                     :href="getLargestAvailableImage(k.bilder[0].filenames)">
                    <responsive-image :alt="k.kabinen_deck"
                                      :title="k.kabinen_deck"
                                      :src="getLargestAvailableImage(k.bilder[0].filenames)"
                                      :src-xs="k.bilder[0].filenames.img800"
                                      :src-sm="k.bilder[0].filenames.img400"
                                      :src-md="k.bilder[0].filenames.img400"
                                      :src-lg="k.bilder[0].filenames.img800"
                                      class="img-responsive"
                                      img-class="travel-detail-picture img-responsive ship-cabin-plan"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container ship-impressions bg-lightgray ship-detail-sections wider-padding">
          <travel-gallery :bilder="shipData.bilder" :excludes="[0]" class="mt-0"></travel-gallery>
        </div>
        <div v-if="travelData && travelData.length > 0" class="container ship-travels-list wider-padding ship-detail-sections">
          <h2 class="mt-0">Aktuelle Reisen</h2>
          <div class="list-group list-travel" v-cloak>
            <transition-group tag="div" appear class="animate__animated"
                              appear-class="animate__fadeIn"
                              enter-class="animate__fadeInUp"
                              enter-to-class="animate__fadeInUp"
                              leave-to-class="animate__fadeOut">
              <travel-list-item v-for="item in travelData" :key="item.code" :trip-data="item"/>
            </transition-group>
          </div>
        </div>
      </div>
    </section>
  </div>


</template>
<style></style>
<script type="module">
import AnalyticsMixin from '../mixins/analytics-mixin.js';
import ErrorHandlerMixin from '../mixins/error-handler-mixin.js';
import HelperMixin from '../mixins/helper-mixin.js';
import TravelListItem from './_travel-list-item.vue';
import TravelGallery from './_travel-gallery.vue';
import PanoViewer from './_pano-viewer.vue';

export default {
  name: "ship-detail",
  mixins: [AnalyticsMixin, ErrorHandlerMixin, HelperMixin],
  props: {
    shipData: Object,
    tripsEp: String,
    logo: String,
    showCurrentTravels: { type: Boolean, default: true },
    showPano: { type: Boolean, default: true },
    isStandalone: { type: Boolean, default: true}
  },
  components: {
    'travel-list-item': TravelListItem,
    'travel-gallery': TravelGallery,
    'pano-viewer': PanoViewer
  },
  data: function () {
    return {
      travelData: null,
      shipPano: null,
      showShipPano: false
    }
  },
  computed: {
      hasShipPano: function(){
          if(this.shipPano && this.shipPano.length > 0) return true;
          return false;
      }
  },
  methods: {
    loadShipPano: function (shipcode) {
      if (!shipcode) return;
      var self = this;
      axios.get('/ccm/pano-scenes/' + shipcode)
          .then(function (response) {
            self.shipPano = response.data.scenes;
          })
          .catch(function (error) {
            self.handleApiError(error);
          });
    },
    loadShipTravels: function( code ) {
      var self = this;
      if(this.tripsEp){
        axios.get( this.tripsEp + '?clientEinschraenkung=keine&schiffcodes=' + code )
            .then(function (response) {
              self.travelData = response.data.data;
            })
            .catch(function (error) {
              self.error = error;
            });
      }
    },
    loadFancyBox: function () {
      // Some default configs for Fancyapps
      this.Fancybox.bind('[data-fancybox="deckplan"], [data-fancybox="kabinenplan"], [data-fancybox="programm"]', {
        Thumbs: {
          autoStart: false,
        },
        Toolbar: {
          display: ["close"],
        },
        Image: {
          Panzoom: {
            maxScale: function () {
              return 3;
            },
          },
        },
      });
      this.Fancybox.bind('[data-fancybox="krpano-ship"]', {
        Thumbs: {
          autoStart: false,
        },
        Toolbar: {
          display: ["close"],
        },Carousel: {
          infinite: false,
          touch: false,
        },
        closeButton: 'outside',
        animated: false,
        hideScrollbar: true,
        trapFocus: true,
        dragToClose: false,
        infinite: false,
        touch: false,
        mainClass: 'krpano-wrapper',
        on: {
        },
      });
    },
  },
  mounted(){
    this.loadFancyBox();
  },
  updated() {
    if(this.shipData && this.travelData === null) {
      this.loadShipTravels(this.shipData.schiffscode)
    }
    if(this.shipData && this.shipPano === null) {
      this.loadShipPano(this.shipData.schiffscode);
      if (this.shipPano) {
          initPano();
      }
    }
  }
}
</script>
